export const modalMessages = {
    INTENTO_1_TITLE: 'Por favor, ingresa el número de serie o número de documento asociado a tu RUT.',
    INTENTO_1_DESCRIPTION: 'Te quedan 2 intentos antes de bloquear tu cuenta',
    INTENTO_1_BUTTON: 'Entendido',
    INTENTO_2_DESCRIPTION: 'Te queda 1 intento antes de bloquear tu cuenta',

    CLIENTE_TBK_TITLE: '¡Ya eres cliente!',
    CLIENTE_TBK_DESCRIPTION: 'Consulta los abonos o solicita nuevos productos ingresando al Portal Transbank con tu RUT y contraseña.',
    CLIENTE_TBK_BUTTON: 'Ir al Portal Transbank',

    CEDULA_BLOQUEADA_TITLE: 'Tu cédula de identidad está bloqueada',
    CEDULA_BLOQUEADA_DESCRIPTION: 'Para continuar con la solicitud de un producto, regulariza la situación con las instituciones ' +
        'correspondientes. Luego podrás retomar tu solicitud sin problemas a través del formulario sólo con tu RUT y correo electrónico',
    CEDULA_BLOQUEADA_BUTTON: 'Aceptar',

    BLOQUEO_3_INTENTOS_TITLE: 'Lo sentimos, no puedes continuar con la contratación.',
    BLOQUEO_3_INTENTOS_DESCRIPTION: 'Superaste el número de intentos y por seguridad bloqueamos tu cuenta. ' +
        'Espera 24 hrs e inténtalo nuevamente.',
    BLOQUEO_3_INTENTOS_BUTTON: 'Entendido',
    BLOQUEO_3_INTENTOS_IMAGE: '../../../assets/icons/icon-bloqueo.svg',

    SS_EN_PROCESO_TITLE: 'Tienes una solicitud en proceso',
    SS_EN_PROCESO_DESCRIPTION: 'Si tienes dudas sobre el estado de tu solicitud, comunícate con nuestro Contact Center al <strong>600 638 6380</strong> ' +
        'o al <strong>+56 2 2661 2700</strong> desde tu celular y un ejecutivo te ayudará a resolver tus preguntas.<br><br>Recuerda que estamos ' +
        'disponibles de lunes a domingo desde las 09:00 hasta las 22:00 horas.',
    SS_EN_PROCESO_BUTTON: 'Entendido',

    SOLICITUD_VACIA_TITLE: 'Solicitud vacía',
    SOLICITUD_VACIA_DESCRIPTION: 'Para continuar con el proceso, debes tener un producto agregado',
    SOLICITUD_VACIA_BUTTON: 'Agregar productos',
    SOLICITUD_VACIA_BUTTON_SECONDARY: 'Continuar',


    CAMBIO_PRODUCTO_RECHAZADO_TITLE: 'Solicitud en proceso',
    CAMBIO_PRODUCTO_RECHAZADO_DESCRIPTION: 'Se ha detectado que el producto actual no puede ser cambiado en esta etapa de la solicitud. Por lo que solo puede continuar la solicitud actual.',
    CAMBIO_PRODUCTO_RECHAZADO_BUTTON: 'Continuar solicitud',
    CAMBIO_PRODUCTO_RECHAZADO_BUTTON_SECONDARY: 'Cancelar',

    CONTRATACION_NO_INICIADA_TITLE: 'Aún no has comenzado tu contratación con Transbank',
    CONTRATACION_NO_INICIADA_DESCRIPTION: 'Inicia tu contratación seleccionado el producto que más se adecúe a tus necesidades.',
    CONTRATACION_NO_INICIADA_BUTTON: 'Regresar al inicio',

    RETOMA_TITLE: 'Retomar contratación',
    RETOMA_BUTTON_RETOMAR: 'Retomar',
    RETOMA_BUTTON_PRODUCTOS: 'Ir a lista de productos',

    REINTENTAR_BUTTON: 'Reintentar',

    REFRESH_TOKEN: {
      TITLE: 'Finalizó el tiempo que tenías para realizar la solicitud.',
      BODY: 'Para continuar la solicitud, intenta nuevamente.',
      BTN: 'Entendido'
    },

    pdfViewer: {
        title: 'Revisa el contrato de <span>solicitud<span>',
        download: 'Descargar contrato de solicitud en PDF',
        button: 'Entendido'
    },
    resumeHiring: {
        title: 'Retomar contratación',
        description: 'Se guardaron tus datos ingresados del paso 2 y tu del producto Máquina POS <strong>feria o eventos</strong>',
        question: '¿Deseas retomar la solicitud?',
        actions: {
            primary: 'Retomar',
            secondary: 'Ir a lista de productos'
        }
    },
    accessWithoutHiring: {
        title: 'Aún no has comenzado tu contratación con Transbank',
        description: 'Inicia tu contratación seleccionando el producto que más se adecúe a tus necesidades.',
        action: 'Regresar al inicio'
    },
    deleteProduct: {
        title: 'Eliminar producto',
        description: '¿Estás seguro que deseas eliminar ',
        description2: 'Los productos serán eliminados de tu orden',
        actions: {
            secondary: 'Regresar',
            primary: 'Si, eliminar'
        }
    },
    changeProduct: {
        title: 'Cambiar producto',
        description: '¿Estás seguro que deseas cambiar ',
        description2: 'Si deseas continuar, serás direccionado a la selección de productos/servicios.',
        actions: {
            secondary: 'Regresar',
            primary: 'Si, cambiar producto'
        }
    },
    cuentaBancaria: {
        rutIngresadoPerteneceAEmpresa: {
            title: 'El RUT ingresado pertenece a RUT de empresa',
            description: '¿Quieres ingresar una cuenta de tipo empresa?',
            actions: {
                primary: 'Ingresar cuenta empresa',
                secondary: 'No, modificar el RUT'
            }
        },
        rutIngresadoPerteneceAPropia: {
            title: 'Has ingresado tu propio RUT',
            description: '¿Quieres ingresar una cuenta que esté a tu nombre?',
            actions: {
                primary: 'Ingresar cuenta propia',
                secondary: 'No, modificar el RUT'
            }
        }
    },
    fechaAgendamientoVencida: {
        title: 'Fecha de agendamiento caducada',
        description: 'Para continuar con el proceso, debes seleccionar una nueva fecha de entrega',
        action: 'Continuar'
    }
};
